module.exports = "/_next/static/images/PowerDelivery-b35c60a2ccc318032247136191d4ec3d.webp";